export const MOCK_ALL_CATEGORY_SLIDER_ITEM = {
  name: 'All',
  value: '',
  productId: 0,
  items: [],
};
